import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FileText, Truck, Users } from "lucide-react";
import Button from "../../../components/common/Button";

const HeroSection = () => {
  // 배경 이미지 로드 상태 (실패/지연 대비 단색 폴백 + blur-up)
  const [bgLoaded, setBgLoaded] = useState(false);
  const [bgError, setBgError] = useState(false);

  // 신뢰 지표 (목업 누적 수치)
  const trustStats = [
    { icon: FileText, value: "12,800+", label: "누적 부고 등록" },
    { icon: Truck, value: "31,500+", label: "화환 배송 완료" },
    { icon: Users, value: "98%", label: "고객 만족도" },
  ];

  return (
    <section
      className="relative bg-charcoal text-ivory py-24 sm:py-32 md:py-40 lg:py-48"
      role="img"
      aria-label="장례식장 분위기의 배경 이미지 위에 표시된 모바일 장례 서비스 소개"
    >
      {/* 숨겨진 img 로 실제 로드/실패를 감지해 blur-up 전환 */}
      <img
        src="/images/hero.jpg"
        alt=""
        aria-hidden="true"
        className="hidden"
        onLoad={() => setBgLoaded(true)}
        onError={() => setBgError(true)}
      />

      {/* Background Image (로드 완료 시 페이드인, 실패 시 단색 폴백 유지) */}
      {!bgError && (
        <div
          className={`absolute inset-0 bg-cover bg-center bg-no-repeat transition-opacity duration-700 ${
            bgLoaded ? "opacity-100" : "opacity-0"
          }`}
          style={{ backgroundImage: "url('/images/hero.jpg')" }}
          aria-hidden="true"
        />
      )}

      {/* Gradient Overlay */}
      <div
        className="absolute inset-0 bg-gradient-to-b from-charcoal/40 via-gray-800/30 to-gray-900/40"
        aria-hidden="true"
      />

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 tracking-tight text-ivory drop-shadow-[0_2px_8px_rgba(0,0,0,0.8)]">
          모바일 장례 서비스
        </h1>
        <p className="text-xl md:text-2xl text-gray-200 mb-10 max-w-2xl mx-auto drop-shadow-[0_2px_6px_rgba(0,0,0,0.7)]">
          마음을 전하는 가장 쉬운 방법
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link to="/obituaries/create">
            <Button variant="primary" size="lg">
              부고 작성하기
            </Button>
          </Link>
          <Link to="/obituaries">
            <Button variant="secondary" size="lg">
              부고 찾기
            </Button>
          </Link>
        </div>

        {/* 신뢰 지표 */}
        <dl className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto">
          {trustStats.map((stat) => {
            const Icon = stat.icon;
            return (
              <div
                key={stat.label}
                className="flex flex-col items-center rounded-lg bg-white/10 backdrop-blur-sm px-4 py-5"
              >
                <Icon size={24} className="mb-2 text-ivory" aria-hidden="true" />
                <dt className="sr-only">{stat.label}</dt>
                <dd className="text-2xl font-bold text-ivory">{stat.value}</dd>
                <span className="mt-1 text-sm text-gray-200">{stat.label}</span>
              </div>
            );
          })}
        </dl>
      </div>
    </section>
  );
};

export default HeroSection;
